export const relocate = (url: string): void => {
  if (typeof window !== 'undefined') {
    window.location.href = url;
  }
};
